<template>
  <FullPageLayout id="bilpop-container" hide-footer class="bg-bilpop">
    <Bilpop />
  </FullPageLayout>
</template>

<script>
import { defineComponent, onMounted } from '@nuxtjs/composition-api';
import FullPageLayout from '~/modules/common/components/layout/FullPageLayout';
import Bilpop from '~/modules/bilpop/components/Bilpop.vue';
export default defineComponent({
  components: { FullPageLayout, Bilpop },
  setup() {
    // set screen height
    const calculateScreenHeight = () => {
      const el = document.getElementById('bilpop-container');
      const height = window.innerHeight;
      el.style.minHeight = `${height}px`;
    };

    onMounted(() => {
      calculateScreenHeight();
      window.addEventListener('resize', calculateScreenHeight);
    });
    return {};
  },
});
</script>

<style lang="scss">
.bg-bilpop {
  background: #5c1fa3;
  background: -webkit-linear-gradient(166.34deg, #400677 -6.27%, #6e2fbf 106.87%);
  background: linear-gradient(166.34deg, #400677 -6.27%, #6e2fbf 106.87%);
}
</style>
